import castArray from 'lodash/castArray'
import filter from 'lodash/filter'
import map from 'lodash/map'
import React, { cloneElement, ReactElement, useMemo, VFC } from 'react'
import styled, { css } from 'styled-components'

import { Crumb, CrumbProps } from '@Components/Breadcrumbs/Crumb'
import { down } from '@Globals/Style/breakpoints'

const BreadcrumbWrapper = styled.section<{ hideOnSmallerScreens: boolean }>(({ hideOnSmallerScreens, theme }) => `
  margin-bottom: 20px;
  height: 22px;
  line-height: 1.4;
  font-size: 0.66rem;
  color: ${theme.colors.grey};
  padding-top: 4px;

  ${hideOnSmallerScreens
    ? css`
      ${down('tablet')} {
        display: none;
      }
    `
    : ''};
  ${down('tablet')} {
    margin-bottom: 10px;
  }

  *, *:before {
    line-height: inherit;
    color: inherit;
    font-size: inherit;
  }
`)

const CrumbBucket = styled.ol(() => `
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  list-style: none;
  padding: 0;
  margin: 0;
`)

type BreadcrumbItem = ReactElement<CrumbProps, typeof Crumb> | undefined | null | boolean | '' | 0

interface BreadcrumbsProps {
  children?: BreadcrumbItem[] | BreadcrumbItem
  className?: string
  hideOnSmallerScreens?: boolean
}

export const Breadcrumbs: VFC<BreadcrumbsProps> = ({
  children,
  className,
  hideOnSmallerScreens = false,
}: BreadcrumbsProps) => {
  const items = useMemo(() => filter(castArray(children)), [children])

  if (items.length === 0) {
    return null
  }

  return (
    <BreadcrumbWrapper className={className} hideOnSmallerScreens={hideOnSmallerScreens}>
      <CrumbBucket itemScope itemType="https://schema.org/BreadcrumbList">
        {map(
          items,
          (item: ReactElement, itemIndex) => cloneElement(
            item,
            { position: itemIndex, key: itemIndex },
          ),
        )}
      </CrumbBucket>
    </BreadcrumbWrapper>
  )
}
